<script lang="ts">
import GuestLayout from "@/layouts/GuestLayout.vue"

export default { layout: GuestLayout }
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref } from "vue"

import NinjanizrMark from "@/assets/mark.svg?component"
import { useAccounts } from "@/composables/useAccounts"
import { ICON } from "@/lib/icons"
import { accountPath, sessionPath } from "@/routes"

const { accounts } = useAccounts()
const loadingAccountId = ref<string | null>(null)

function selectAccount(id: string) {
  loadingAccountId.value = id
  router.patch(
    accountPath(id),
    {},
    {
      onFinish: () => {
        loadingAccountId.value = null
      },
    },
  )
}

function signOut() {
  router.delete(sessionPath())
}
</script>

<template>
  <Head title="Choose an inventory" />

  <main class="space-y-6">
    <div class="text-center">
      <p class="text-highlighted text-sm font-bold">Ninjanizr</p>
      <h1 class="text-highlighted mt-2 text-2xl font-bold">Choose an inventory</h1>
      <p class="text-muted mt-2 text-sm">Where would you like to go today?</p>
    </div>

    <div class="space-y-4">
      <UButton
        v-for="account in accounts"
        :key="account.id"
        color="neutral"
        variant="outline"
        size="xl"
        block
        class="min-h-16 justify-start text-left"
        :loading="loadingAccountId === account.id"
        :disabled="loadingAccountId !== null"
        @click="selectAccount(account.id)"
      >
        <NinjanizrMark class="size-8 shrink-0" />
        <span class="text-highlighted min-w-0 flex-1 truncate font-semibold">
          {{ account.name }}
        </span>
        <UIcon :name="ICON.chevronRight" class="text-muted size-5 shrink-0" />
      </UButton>
    </div>

    <div class="flex justify-center">
      <UButton
        label="Sign out"
        :icon="ICON.signOut"
        color="neutral"
        variant="link"
        @click="signOut"
      />
    </div>
  </main>
</template>
